import Cookie from 'js-cookie'
let hasPerm = function (auth) {
  let permissionArrStr = Cookie.get('behaviors')
  let permissionArr = permissionArrStr.split(',')
  if (permissionArr.indexOf(auth) !== -1) {
    return true
  } else {
    return false
  }
}
// WorkApprove_Agree,WorkApprove_Refuse,MonthAttendance_Lock,Bill_OncePay,Bill_CyclicalPay,Bill_Cancel,Bill_Edit,Bill_Publish,Bill_Delete,Bill_Receipt,Bill_Refund
export {hasPerm}



// WEBPACK FOOTER //
// ./src/utils/hasPerm.js